import type { PropsWithChildren } from 'react';

export const ChatBody = ({ children }: PropsWithChildren) => (
  <div className="sgwt-chatbot-body card-body overflow-y-auto scrollbar-sm d-flex flex-column h-100 px-4">{children}</div>
);
